import { classNames } from '@commenda/utils';
import { VALIDATION_MESSAGES } from '../../constants';

export function SkippedFilingCard() {
  return (
    <div
      className={classNames(
        'rounded-lg border-l-4 p-3 h-full',
        'bg-utility-error-500',
        'border-utility-error-500',
        'border-l-utility-error-300',
        'border'
      )}
    >
      <div className="flex flex-col gap-1">
        <h4 className="txt-extra-small-bold text-white">Skipped Filing</h4>
        <p className="txt-extra-small-regular text-utility-error-100">
          {VALIDATION_MESSAGES.COVERAGE_GAP}
        </p>
      </div>
    </div>
  );
}
